<template>
  <button v-bind="$attrs" v-on="$listeners">
    <div class="button-container">
      <slot></slot>
    </div>
  </button>
</template>

<script>
  export default {
    name: 'button-el'
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  button {
    @include clear-button();
  }

  .button-container {
    width: 100%;
    height: 100%;
  }
</style>
